import { Clock } from "lucide-react";

import { useActivity } from "@/lib/api";
import { formatActionLabel, formatDateTime, formatDetail } from "@/lib/format";

export function ActivityList() {
  const { data: entries = [], isLoading } = useActivity();

  if (isLoading) {
    return <div className="text-muted py-8 text-center text-sm">Loading activity...</div>;
  }

  if (entries.length === 0) {
    return <p className="text-muted py-8 text-center text-sm">No activity recorded yet.</p>;
  }

  return (
    <div className="max-h-96 space-y-1 overflow-y-auto pr-1">
      {entries.map((entry) => {
        const detailStr = formatDetail(entry.detail);
        return (
          <div
            key={entry.id}
            className="hover:bg-secondary/60 flex items-start gap-3 rounded-md px-2 py-2 transition-colors"
          >
            <div className="bg-secondary mt-0.5 flex size-7 shrink-0 items-center justify-center rounded-full">
              <Clock className="text-muted size-3.5" />
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-foreground text-sm font-medium">
                {formatActionLabel(entry.action)}
              </p>
              {detailStr && <p className="text-muted mt-0.5 truncate text-xs">{detailStr}</p>}
            </div>
            <span className="text-muted mt-0.5 shrink-0 text-xs">
              {formatDateTime(entry.created_at)}
            </span>
          </div>
        );
      })}
    </div>
  );
}
